import React from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';

import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import { Typography, Avatar } from '@material-ui/core';

import { Container } from './styles';

function Informations({ setAnchorEl }) {
  const profile = useSelector((state) => state.user.profile);

  const [name, surname] = profile.name.split(' ');

  return (
    <Container onClick={(event) => setAnchorEl(event.currentTarget)}>
      {profile.avatar ? (
        <Avatar
          className="avatar"
          alt={profile.name}
          src={profile.avatar.url}
        />
      ) : (
        <Avatar className="avatar">
          {profile.name.charAt(0).toUpperCase()}
        </Avatar>
      )}

      <div className="informations">
        <Typography className="name">
          {surname ? `${name} ${surname}` : name}
        </Typography>
        <Typography className="register">{profile.register}</Typography>
      </div>

      <ExpandMoreIcon />
    </Container>
  );
}

Informations.propTypes = {
  setAnchorEl: PropTypes.func.isRequired,
};

export default Informations;
